import { useEffect, useState, useContext } from "react";
import {
  Grid,
} from "@mui/material";
import Mandant from "../forms/mandats/Mandant";
import { _STYLES } from "../../utils/_style_constants";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import { UserContext } from "../contexts/UserContext";
import { RequestHelper } from "../../utils/requestHelper";
import _ from "lodash";
import {
  _ACTIONS,
  _BAIL_A_NOURRITURE,
  _EN_COURS_SIGNATURE,
  _GESTION_VIAGERE,
  _SIGNE,
  _VENTE_TRADITIONNELLE,
} from "../../utils/_constants";
import CreationLettreIntentionAchat from "../forms/mandats/CreationLettreIntentionAchat";
import DescriptionBienLettreIntentionAchat from "../forms/mandats/DescriptionBienLettreIntentionAchat";
import VentilationPrixLettreIntentionAchat from "../forms/mandats/VentilationPrixLettreIntentionAchat";
import RemunerationAgence from "../forms/mandats/RenumerationAgence";
import AutresLettreIntentionAchat from "../forms/mandats/AutresLettreIntentionAchat";
import BoxActionLettreIntentionAchat from "../forms/mandats/BoxActionLettreIntentionAchat";

const LettreIntentionAchat = () => {
  const { user } = useContext(UserContext);
  const [civilites, setCivilites] = useState([]);
  const [users, setUsers] = useState([]);
  const [currentMandat, setCurrentMandat] = useState([]);
  const [typeMandants, setTypeMandants] = useState([]);
  const [typeVentes, setTypeVentes] = useState([]);
  const [refreshMandat, setRefreshMandat] = useState(0);
  const [indices, setIndices] = useState([]);
  const requestHelper = new RequestHelper();
  const currentIdUrl = useParams();

  const mandantListNonSignataire = currentMandat?.mandants?.filter(
    (mandants) =>
      mandants.onlyForSignature === false || mandants.onlyForSignature === null,
  );

  const disabledSign =
    currentMandat?.statut?.nom === _SIGNE ||
    currentMandat?.statut?.nom === _EN_COURS_SIGNATURE;

  /* GET User Entity */
  useEffect(() => {
    getCivilite();
    getUsers();
    getTypeMandant();
    getTypeDeVente();
    getIndice();
  }, []);
  const {
    register,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  useEffect(() => {
    getUsers();
    /* GET Mandat by Id */
    getMandatById();
  }, [refreshMandat, user]);

  /* Va en haut de la page à l'ouverture */
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const getCivilite = () => {
    requestHelper.get("/api/civilites").then((response) => {
      setCivilites(response.data["hydra:member"]);
    });
  };

  const getUsers = () => {
    // on récupére l'agence du mandat
    let agenceAPi = currentMandat?.agence ? currentMandat.agence.id : "";
    // si le mandat est null, on récupére l'agence de l'utilisateur
    if (
      agenceAPi === "" &&
      !_.isUndefined(user.agencesList) &&
      users.length === 0
    ) {
      agenceAPi = user.agencesList;
      // on supprime la derniére virgule
      if (agenceAPi[agenceAPi.length - 1] === ",") {
        agenceAPi = agenceAPi.slice(0, -1);
      }
      let param = [];
      agenceAPi = agenceAPi.split(",");
      agenceAPi.forEach((element, index) => {
        param.push("agences[]=" + element);
      });
      param.push("represent=true");
      param.push("actif=true");

      requestHelper.get("/api/users?" + param.join("&")).then((response) => {
        setUsers(response.data["hydra:member"]);
      });
    }
  };

  const getTypeDeVente = () => {
    requestHelper.get("/api/type_ventes").then((response) => {
      /** Filtre Pour gestion Viagére à mettre uniquement pour admin et sadmin */
      let arrayList = response.data["hydra:member"];
      let finalArrayList = [];
      arrayList.forEach((item) => {
        if (user.profil === "SUSER" || user.profil === "USER") {
          if (
            item.nom !== _GESTION_VIAGERE &&
            item.nom !== _VENTE_TRADITIONNELLE &&
            item.nom !== _BAIL_A_NOURRITURE
          ) {
            finalArrayList.push(item);
          }
        } else {
          finalArrayList.push(item);
        }
      });
      setTypeVentes(finalArrayList);
    });
  };

  const getMandatById = () => {
    requestHelper
      .doRequest(_ACTIONS.GET, `/api/mandats/${currentIdUrl.id}`)
      .then((response) => {
        if (response.status === 200) {
          setCurrentMandat(response.data);
        }
      });
  };

  const getTypeMandant = () => {
    requestHelper.get("/api/type_mandants").then((response) => {
      setTypeMandants(response.data["hydra:member"]);
    });
  };

  const getIndice = () => {
    requestHelper.get("/api/indices").then((response) => {
      setIndices(response.data["hydra:member"]);
    });
  };

  /** Fonction pour refresh le mandat  */
  const refresh = () => {
    setRefreshMandat(refreshMandat + 1);
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          border: "2px solid rgb(238, 238, 238)",
          borderRadius: "10px",
          gap: "1rem",
          padding: 4,
          margin: 1,
        }}
      >
        <Grid sx={{ width: "100%" }}>
          <CreationLettreIntentionAchat
            register={register}
            errors={errors}
            currentMandat={currentMandat}
            setCurrentMandat={setCurrentMandat}
            refresh={refresh}
            disabledSign={disabledSign}
            typeVentes={typeVentes}
          />
        </Grid>
        <Grid sx={{ ..._STYLES.sxGridChild }}>
          <Mandant
            register={register}
            errors={errors}
            typeMandants={typeMandants}
            setTypeMandants={setTypeMandants}
            currentMandat={currentMandat}
            setCurrentMandat={setCurrentMandat}
            civilites={civilites}
            refresh={refresh}
            requestHelper={requestHelper}
            disabledSign={disabledSign}
            mandantListNonSignataire={mandantListNonSignataire}
            proposant={true}
          />
        </Grid>

        <Grid sx={{ ..._STYLES.sxGridChild }}>
          <DescriptionBienLettreIntentionAchat
            register={register}
            errors={errors}
            currentMandat={currentMandat}
            setCurrentMandat={setCurrentMandat}
            refresh={refresh}
            disabledSign={disabledSign}
          />
        </Grid>

        <Grid sx={{ ..._STYLES.sxGridChild, backgroundColor: "#f7e0eb" }}>
          <VentilationPrixLettreIntentionAchat
            register={register}
            errors={errors}
            indices={indices}
            currentMandat={currentMandat}
            setCurrentMandat={setCurrentMandat}
            refresh={refresh}
            requestHelper={requestHelper}
            disabledSign={disabledSign}
          />
        </Grid>
        <RemunerationAgence
          currentMandat={currentMandat}
          setCurrentMandat={setCurrentMandat}
          refresh={refresh}
          register={register}
          field={"libre"}
          disabledSign={disabledSign}
        />

        <AutresLettreIntentionAchat
          currentMandat={currentMandat}
          setCurrentMandat={setCurrentMandat}
          refresh={refresh}
          register={register}
          field={"libre"}
          disabledSign={disabledSign}
        />
      </Grid>
      {/*<Grid sx={{ ..._STYLES.sxGridChild }}>
        <Box sx={{ flexGrow: 1, padding: 4 }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography
                variant="h5"
                style={{
                  fontWeight: "bold",
                  color: _COLORS.primary,
                }}
              >
                Signatures
              </Typography>
            </Grid>
            {/*<Grid item xs={12} sx={{ display: "flex", gap: 2 }}>
              <Typography>Signataire des mandataires</Typography>
              <Grid item xs={4}>
                <fieldset disabled={disabledSign}>
                  <FormControl fullWidth>
                    <InputLabel id="signature-label"> Signataire</InputLabel>
                    <Select
                      labelId="signature-label"
                      label="Signataire"
                      sx={{ border: "none" }}
                      size="small"
                      {...register("signataire", { required: false })}
                      value={
                        currentMandat?.signataire
                          ? currentMandat?.signataire?.["@id"]
                          : ""
                      }
                      fullWidth
                      disabled={disabledSign}
                      onChange={(e) => {
                        let value =
                          e.target.value === "null" ? null : e.target.value;
                        let m = editInstantRequest(
                          value,
                          currentMandat["@id"],
                          "signataire",
                        );

                        m.then((m) => {
                          if (m["@context"] === "/api/contexts/Error") {
                            refresh();
                          } else {
                            setCurrentMandat(m);
                          }
                        });
                      }}
                    >
                      <MenuItem value="null">Aucun Signataire</MenuItem>
                      {users.map((u, i) => (
                        <MenuItem key={i} value={u["@id"]}>
                          {u.prenom + " " + u.nom}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </fieldset>
              </Grid>
            </Grid> 
          </Grid>
        </Box>
      </Grid>-- supprimé le 11/07/2025*/}
      <BoxActionLettreIntentionAchat
        requestHelper={requestHelper}
        refresh={refresh}
        currentMandat={currentMandat}
        disabledSign={disabledSign}
      />
    </>
  );
};

export default LettreIntentionAchat;
